export default __webpack_public_path__ + "static/logo34-215cd83a06fe1e219a529fdb89eff3fd.png";